import {VentrataDataProvider} from 'components/common/CartItemBuilder/providers/VentrataDataProvider'
import {useCallback} from 'react'
import {Ventrata} from 'types'
import {ga4} from 'utils/ga4'
import {StepDataProvider} from '../../../../../providers/StepDataProvider/StepDataProvider'
import {Button} from './Button'

type Props = {
  unit: Ventrata.Unit
}

const useUnitCounter = (unitId: string) => {
  const dataManager = StepDataProvider.useGuestsDataManager()
  const unitCounters = dataManager.getData()
  return unitCounters[unitId] || 0
}

export const useUnitCounterSetter = () => {
  const dataManager = StepDataProvider.useGuestsDataManager()

  return useCallback(
    (unitId: string, quantity: number) => {
      dataManager.update((unitCounters) => {
        return {
          ...unitCounters,
          [unitId]: quantity,
        }
      })
    },
    [dataManager]
  )
}

export const Counter = ({unit}: Props) => {
  const product = VentrataDataProvider.useProduct('optional')
  const unitCounter = useUnitCounter(unit.id)
  const setUnitCounter = useUnitCounterSetter()

  const onCounterChange = useCallback(
    (newCounterValue: number) => {
      setUnitCounter(unit.id, newCounterValue)

      ga4({
        event: 'select_unit',
        label: unit.title,
        item_id: product.id,
        item_name: product.title,
        checkout_type: 'custom_checkout',
      })
    },
    [product, unit, setUnitCounter]
  )

  return (
    <div className="flex gap-2 items-center">
      <Button type="minus" disabled={unitCounter === 0} onClick={() => onCounterChange(unitCounter - 1)} />

      <div className="font-bold text-xl min-w-6 text-center">{unitCounter}</div>

      <Button type="plus" disabled={false} onClick={() => onCounterChange(unitCounter + 1)} />
    </div>
  )
}
